$(function(){

  const $menu = $('.sp-menu');
  const $toggle = $('.menu-toggle');
  const $headerNav = $('.header-wrap');
  const $bodyNav = $('body');

  // 初期位置を取得
  const navOffset = $headerNav.offset().top;

  /* =========================
    ハンバーガー開閉
  ========================= */
  $toggle.on('click', function(e){
    e.stopPropagation();

    $menu.toggleClass('open');
    $('body').toggleClass('no-scroll');

    $toggle.toggleClass('active');
  });

  /* =========================
    アコーディオン
  ========================= */
  $('.accordion-btn').on('click', function(e){
    e.stopPropagation();

    const $btn = $(this);
    const $target = $btn.next();

    $btn.toggleClass('active');

    if ($target.hasClass('open')) {
      $target.stop(true, true).slideUp(200).removeClass('open');
    } else {
      $target.stop(true, true).slideDown(200).addClass('open');
    }
  });

  /* =========================
    外クリックで閉じる
  ========================= */
  $(document).on('click', function(e){
    if (!$(e.target).closest('.sp-menu, .menu-toggle').length) {
      $menu.removeClass('open');
      $('body').removeClass('no-scroll');

      $toggle.removeClass('active');
    }
  });

  /* =========================
    追従
  ========================= */
  $(window).on('scroll', function(){
    if ($(window).scrollTop() > navOffset) {
      $headerNav.addClass('is-fixed');
      $bodyNav.addClass('is-fixed');
    } else {
      $headerNav.removeClass('is-fixed');
      $bodyNav.removeClass('is-fixed');
    }
  });

});

$(function(){

  /* =========================
    判定（SPのみ）
  ========================= */
  function isSP() {
    return window.innerWidth <= 749;
  }

  /* =========================
    初期処理（アイコン用クラス付与）
  ========================= */
  function initMenu() {

    $('.menu-level-1 > .menu-item').each(function(){

      const $li = $(this);
      const $child = $li.children('.menu-level-2');

      // 子メニューがある場合
      if ($child.length) {
        $li.children('.menu-link').addClass('has-icon');

        // SP時は初期非表示
        if (isSP()) {
          $child.hide();
        } else {
          $child.show();
        }
      }

    });

  }

  initMenu();

  /* =========================
    クリックで開閉
  ========================= */
  $('.menu-level-1 > .menu-item > .menu-link').on('click', function(e){

    if (!isSP()) return;

    const $li = $(this).closest('.menu-item');
    const $target = $li.children('.menu-level-2');

    if ($target.length) {
      e.preventDefault(); // 遷移止める

      $li.toggleClass('active');
      $target.stop().slideToggle(200);
    }

  });

  /* =========================
    リサイズ対応
  ========================= */
  $(window).on('resize', function(){
    initMenu();
  });

});